import { OmitByValueType } from 'utils/tsHelpers';

export type Duration = `${number}s` | `${number}ms`;

export type Style = Partial<OmitByValueType<CSSStyleDeclaration, (...args: any) => any>>;

export enum TransitionStopReason {
  end = 'end',
  cancel = 'cancel',
}
